import { purchaseOrderStatusEnum } from "beitary-shared";
import { BSelect } from "components";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export interface PurchaseOrderStatusSelectProps {
  onChange?: (value: string | undefined) => void;
  error?: ReactNode;
  value?: string; // could be undefined if form has no initial values
  disabled?: boolean;
}

export const PurchaseOrderStatusSelect = (
  props: PurchaseOrderStatusSelectProps
) => {
  const { t } = useTranslation();
  const data = purchaseOrderStatusEnum.options.map((o) => ({
    value: o,
    label: t(o),
  }));

  return (
    <BSelect
      {...props}
      required
      data={data}
      label={t("STATUS")}
      nothingFound={t("NOTHING_FOUND")}
    />
  );
};
